export default {
  state: {

    files:{
      derivacion: null,
      codigoDerivacion: null,
      mspPaciente: null,
      mspTitular1: null,
      mspTitular2: null,
      mspTitular3: null,
      solicitudImagen : null,
      solicitudLaboratorio : null
      
    },

    filesIdentificaciones:null

  },

  mutations: {

    setFiles(state, newData){
      state.files = newData
    },

    setFilesIdentificaciones(state, newData){
      state.filesIdentificaciones = newData
    },

    resetFiles(state){
      state.files = {
        derivacion: null,
        codigoDerivacion: null,
        mspPaciente: null,
        mspTitular1: null,
        mspTitular2: null,
        mspTitular3: null,
        solicitudImagen : null,
        solicitudLaboratorio : null

      }
    },

  },
  
};